import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromInvoice from '.';

const log = new LoggingService();

export const InvoiceManagementRoute: Ng2StateDeclaration = {
    // name: 'invoice.**'
    name: 'invoice.management',
    url: '/management',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.invoiceModule)
    data: { requiresAuth: true },
    component: fromInvoice.InvoiceManagementContainerComponent
};
